<script setup>
import VueApexCharts from "vue3-apexcharts";
import usePMPKChart from "../hooks/usePMPKChart.js";
import usePMPKTreeChart from "../hooks/usePMPKTreeChart.js";

const { loadReport: loadType2, data: chartDataType2 } = usePMPKTreeChart(
  2,
  "treemap"
);
const { loadReport: loadType1, data: chartDataType1, total } = usePMPKChart(1);

loadType1();
loadType2();
</script>

<template>
  <div class="ras-charts">
    <h2 class="ras-charts__header">Поставщики услуг</h2>
    <div class="ras-charts__total">
      Образовательные программы реализуются в {{ total }} ОУ
    </div>
    <div class="ras-charts__schoolStundents">
      <VueApexCharts v-bind="chartDataType2" height="308px" />
      <VueApexCharts v-bind="chartDataType1" height="510px" />
    </div>
  </div>
</template>
<style lang="scss">
.ras-charts__schoolStundents .vue-apexcharts svg {
  overflow: visible;
}

.ras-charts__schoolStundents .vue-apexcharts svg foreignObject {
  overflow: scroll;
}
.ras-charts__schoolStundents .apexcharts-legend {
  position: relative;
  height: 308px;
  overflow: visible;
  margin-left: auto;
}
</style>
